import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import DetailsPage from './pages/DetailsPage';
import RSVPPage from './pages/RSVPPage';
import GalleryPage from './pages/GalleryPage';
import RegistryPage from './pages/RegistryPage';
import InvitePage from './pages/InvitePage';
import SeatingChartPage from './pages/SeatingChartPage';
import DirectionsPage from './pages/DirectionsPage';
import WeddingPhotosPage from './pages/WeddingPhotosPage';
import PhotoCategoryPage from './pages/PhotoCategoryPage';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/details" element={<DetailsPage />} />
          <Route path="/rsvp" element={<RSVPPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/registry" element={<RegistryPage />} />
          <Route path="/invite" element={<InvitePage />} />
          <Route path="/seating" element={<SeatingChartPage />} />
          <Route path="/directions" element={<DirectionsPage />} />
          <Route path="/photos" element={<WeddingPhotosPage />} />
          <Route path="/photos/:category" element={<PhotoCategoryPage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
